import React from 'react'
import PropTypes from 'prop-types'
import CONFIG from '../../../config'
import CategoryDefaultImage from '../../../assets/category_default_image.png'
import ModalControlled from '../../shared/ModalControlled/containers/ModalControlledContainer'
import {
  Form, Radio, Button, Table, Header, Pagination, Label,
  Input, Tab, Checkbox, Dimmer, Dropdown, Icon, Image, Item, Grid
} from 'semantic-ui-react'
import './TransactionsView.scss'

import _ from 'lodash';
import moment from 'moment'

import {getLanguageScope, S, C} from '../../../helpers'

import 'react-dates/initialize';
import {DateRangePicker, isInclusivelyBeforeDay} from 'react-dates';

const _i18n = getLanguageScope('transactions');

export default class TransactionsView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      filterFocusedInput: null,
      transactionToCancel: ''
    };

    this.onFilterDatesUpdate = this.onFilterDatesUpdate.bind(this);
    this.onFilterDatesChanged = this.onFilterDatesChanged.bind(this);
    this.renderActionButtons = this.renderActionButtons.bind(this);
    this.closeCancelModal = this.closeCancelModal.bind(this);
    this.doCancelTransaction = this.doCancelTransaction.bind(this);
  }

  componentDidMount() {
    this.loadTransactions();
  }

  loadTransactions() {
    const {loadTransactions} = this.props;

    loadTransactions && loadTransactions();
  }

  async onFilterDatesChanged({startDate, endDate}) {
    const {changeFilterDates} = this.props;

    const from = startDate && startDate.format('YYYY-MM-DD');
    const to = endDate && endDate.format('YYYY-MM-DD');

    return await changeFilterDates({startDate: from, endDate: to});
  }

  async onFilterDatesUpdate({startDate, endDate}) {
    await this.onFilterDatesChanged({startDate, endDate});

    this.loadTransactions()
  }

  renderTransactions() {
    const {transactions} = this.props;

    if (!(transactions && transactions.length)) {
      return (
        <Table.Row>
          <Table.Cell colSpan={'7'}>{_i18n('transaction_not_found')}</Table.Cell>
        </Table.Row>
      )
    }

    return _.map(transactions, (t, i) => {
      return t.is_bundle ? this.renderBundledTransaction(t, i) : this.renderSingleTransaction(t, i);
    })
  }

  renderActionButtons(item) {
    let cancelTransactionButton = null;
    let canceledTransaction = null;

    if(item.cancelable_transaction){
      cancelTransactionButton = (
        <Button size={'mini'} as={'a'} onClick={() => this.setState(() => ({transactionToCancel: item.payment_guid}))}
                inverted icon='cancel' color={'red'} content='Cancel' />
      )
    }

    if(item.status === 'cancelled'){
      canceledTransaction = (
        <Label color='red' horizontal>
          {_i18n('cancelled')}
        </Label>
      )
    }

    return (
      <React.Fragment>
        {cancelTransactionButton}
        {canceledTransaction}
      </React.Fragment>
    )
  }

  closeCancelModal(){
    this.setState(() => ({transactionToCancel: ''}))
  }

  doCancelTransaction(){
    const {transactionToCancel} = this.state;

    this.closeCancelModal();

    if(transactionToCancel){
      this.props.cancelTransaction(transactionToCancel);
    }
  }

  renderSingleTransaction(transaction, index) {

    const {printReceipt} = this.props;

    const icon = transaction.icon ? `${CONFIG.STATIC_PATH}${transaction.icon}` : CategoryDefaultImage;

    return (
      <Table.Row key={index}>
        <Table.Cell className={'transaction-first_element'} collapsing>
          <Item.Group>
            <Item>
              <Item.Image size='mini' src={icon} />
              <Item.Content>
                <Item.Header className={'transaction_header'} as='span'>{transaction.name}</Item.Header>
                <Item.Extra className={'transaction_extra'}>{`${moment(new Date(transaction.created_date)).format('lll')}`}</Item.Extra>
              </Item.Content>
            </Item>
          </Item.Group>
        </Table.Cell>
        <Table.Cell collapsing>
          {this.renderActionButtons(transaction)}
        </Table.Cell>
        <Table.Cell>{transaction.customer_mobile_number}</Table.Cell>
        <Table.Cell>{C(transaction.price, '$')}</Table.Cell>
        <Table.Cell>{C(transaction.fee, '$')}</Table.Cell>
        <Table.Cell>{C(transaction.total, '$')}</Table.Cell>
        <Table.Cell className={'transaction_border_left'}>
          <Table style={{margin: 0}} basic='very'>
            <Table.Body>
              <Table.Row className={'transaction_border_none'}>
                <Table.Cell>{`${_i18n('received')}:`}</Table.Cell>
                <Table.Cell>{C(transaction.actual_amount, '$')}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>

          <Label as={'a'} onClick={() => printReceipt(transaction.receipt_url)} icon='print' content={_i18n('print_receipt')} />
        </Table.Cell>
      </Table.Row>
    )
  }

  renderBundledTransaction(transaction, index) {

    const {printReceipt} = this.props;

    const bundle = [];

    _.each(transaction.items, (item, item_index) => {

      const lastTableCell = (item_index === 0) ?
        <Table.Cell className={'transaction_border_left'} rowSpan={transaction.items.length}>
          <Table basic='very'>
            <Table.Body>
              <Table.Row className={'transaction_border_none'}>
                <Table.Cell>{`${_i18n('total_price')}:`}</Table.Cell>
                <Table.Cell>{C(transaction.price, '$')}</Table.Cell>
              </Table.Row>
              <Table.Row className={'transaction_border_none'}>
                <Table.Cell>{`${_i18n('total_fee')}:`}</Table.Cell>
                <Table.Cell>{C(transaction.fee, '$')}</Table.Cell>
              </Table.Row>
              <Table.Row className={'transaction_border_none'}>
                <Table.Cell>{`${_i18n('total_amount')}:`}</Table.Cell>
                <Table.Cell>{C(transaction.total, '$')}</Table.Cell>
              </Table.Row>
              <Table.Row className={'transaction_border_none'}>
                <Table.Cell>{`${_i18n('received')}:`}</Table.Cell>
                <Table.Cell>{C(transaction.actual_amount, '$')}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>

          <Label as={'a'} onClick={() => printReceipt(transaction.receipt_url)} icon='print' content={_i18n('print_receipt')} />
        </Table.Cell> :
        null;

      const icon = item.icon ? `${CONFIG.STATIC_PATH}${item.icon}` : CategoryDefaultImage;

      bundle.push(
        <Table.Row key={`${index}_${item_index}`}>
          <Table.Cell className={'transaction-first_element'} collapsing>
            <Item.Group>
              <Item>
                <Item.Image size='mini' src={icon} />
                <Item.Content>
                  <Item.Header className={'transaction_header'} as='span'>{item.name}</Item.Header>
                  <Item.Extra className={'transaction_extra'}>{`${moment(new Date(item.created_date)).format('lll')}`}</Item.Extra>
                </Item.Content>
              </Item>
            </Item.Group>
          </Table.Cell>
          <Table.Cell collapsing>
            {this.renderActionButtons(item)}
          </Table.Cell>
          <Table.Cell>{item.customer_mobile_number}</Table.Cell>
          <Table.Cell>{C(item.price, '$')}</Table.Cell>
          <Table.Cell>{C(item.fee, '$')}</Table.Cell>
          <Table.Cell>{C(item.total, '$')}</Table.Cell>
          {lastTableCell}
        </Table.Row>
      )
    });

    return bundle
  }

  render() {
    const {filter_start_date, filter_end_date} = this.props;
    const {filterFocusedInput, transactionToCancel} = this.state;
    return (
      <React.Fragment>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                <DateRangePicker
                  startDate={filter_start_date}
                  startDateId="filter_start_date"
                  endDate={filter_end_date}
                  endDateId="filter_end_date"
                  small={true}
                  numberOfMonths={1}
                  minimumNights={0}
                  hideKeyboardShortcutsPanel={true}
                  focusedInput={filterFocusedInput}
                  isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                  onDatesChange={this.onFilterDatesChanged}
                  onFocusChange={filterFocusedInput => this.setState({filterFocusedInput})}
                  onClose={this.onFilterDatesUpdate}
                />
              </Table.HeaderCell>
              <Table.HeaderCell/>
              <Table.HeaderCell>
                <Icon name='user' /> {_i18n('customer')}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {_i18n('price')}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {_i18n('fee')}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {_i18n('total')}
              </Table.HeaderCell>
              <Table.HeaderCell/>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.renderTransactions()}
          </Table.Body>
        </Table>

        <ModalControlled onClose={this.closeCancelModal}
                         onNext={this.doCancelTransaction}
                         icon={'trash'}
                         headerText={_i18n('cancel_modal_header')}
                         bodyText={_i18n('cancel_modal_text')}
                         showModal={!!(transactionToCancel)} />

      </React.Fragment>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Transactions/components/TransactionsView.js